//DEVICES
export const GET_DEVICES = 'GET_DEVICES';
export const ERROR_DEVICES = 'ERROR_DEVICES';
export const GET_DEVICES_MASTER_LIST = 'GET_DEVICES_MASTER_LIST';
export const ERROR_DEVICES_MASTER_LIST = 'ERROR_DEVICES_MASTER_LIS';
export const GET_ORG_LIST = 'GET_ORG_LIST';
export const ERROR_ORG_LIST = 'ERROR_ORG_LIST';

//CLEAR DEVICES
export const CLEAR_DEVICES = 'CLEAR_DEVICES'